import { systemRequiredBestChapter } from "./systemUnlockData.js";

/** 시너지 도감 UI, 전투탭 표시, 실제 전투 발동의 공통 해금 챕터. */
export const SYNERGY_CODEX_UNLOCK_CHAPTER = systemRequiredBestChapter("synergy");
